import React from 'react';
import IntroSection from '../components/IntroSection';
import AboutUsSection from '../components/AboutUsSection';
import BlueSectionDivider from '../components/BlueSectionDivider';
import AboutProductsSection from '../components/AboutProductsSection';
import AboutDepartmentsSection from '../components/AboutDepartmentsSection';
import AboutValuesSection from '../components/AboutValuesSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import Story from '../components/Story';
import AboutUsTeam from '../components/AboutUsTeam';

const AboutUs = () =>{
    return (
      <div>
        <IntroSection title="EMPOWER YOUR CAREER IN DIGITAL INNOVATION" paragraph="A team dedicated to delivering high-quality software, tailored to meet unique business needs and accelerate digital transformation." backgroundImage="/about-us-bg.png"/>
        <AboutUsSection/>
        <BlueSectionDivider/>
        <Story/>
        <AboutProductsSection/>
        <BlueSectionDivider/>
        <AboutUsTeam/>
        <AboutDepartmentsSection/>
        <BlueSectionDivider/>
        <AboutValuesSection/>
        <BlueSectionDivider/>
       <ContactSection backgroundColor="#057af0ff"/>
        <Footer/>

        

      </div>
    )
}
export default AboutUs;